import { styled as muiStyled } from '@mui/material/styles';
import { FormControl, Pagination, TextField, List, ListItem } from '@mui/material';
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    typography: {
        fontFamily: '"Noto Sans", sans-serif',
        fontWeightRegular: 300,
        fontWeightMedium: 800,
        fontWeightBold: 900,
    },
});

export const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
    margin: theme.spacing(1),  
    minWidth: 110,
    '& .MuiInputBase-root': {
        height: '40px',
    },
}));

export const StyledPagination = muiStyled(Pagination)(() => ({
    margin: '50px 0px',
    display: 'flex',
    justifyContent: 'center',
}));

export const StyledTextField = muiStyled(TextField)({
    '& .MuiInputBase-input': {
        height: '1em',
    },
});

export const StyledList = muiStyled(List)(({ theme }) => ({
    flex: "1 1 300px",        
    width: "100%",              
    maxWidth: 400,
    height: 400,  
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', 
    border: '1px solid black',
    borderRadius: '10px 10px 10px 10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    backgroundColor: theme.palette.background.paper,
    padding: 0,     
    margin: 0, 
     // Responsivo para mobile
    [theme.breakpoints.down('md')]: {
        minWidth: 'auto',   
        margin: '0 auto 16px', 
        paddingLeft: 0,
        paddingRight: 0,
        minHeight: 'auto',
        '& .MuiDivider-root': {
        backgroundColor: theme.palette.grey[400], 
        height: '0.5px',
        },
        
    },
    '& .MuiListItem-root': {
        margin: 0,        
    },
    '& .MuiListItemText-root': {
        margin: 0,          
    },
}));

export const LightBlueListItem = muiStyled(ListItem)({
    backgroundColor: 'lightblue',
    color: 'white',
    borderRadius: '10px 10px 0px 0px',
    fontSize: '16px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '22px',
    paddingBottom: '22px',
    height: '66px'
});

export const LightGreenListItem = muiStyled(ListItem)({
    backgroundColor: 'lightgreen',
    color: 'white',
    borderRadius: '10px 10px 0px 0px',
    fontSize: '16px',
    textAlign: 'center',
    height: '66px'
});

export const RedListItem = muiStyled(ListItem)({
    backgroundColor: 'red',
    color: 'white',
    borderRadius: '10px 10px 0px 0px',
    fontSize: '16px',
    textAlign: 'center',
    paddingTop: '0',
    paddingBottom: '0',
    height: '66px',
});

export const NoBorderTextField = muiStyled(TextField)({
    '& .MuiInput-underline:before': { borderBottom: 'none' },
    '& .MuiInput-underline:after': { borderBottom: 'none' },
});